import { useEffect, useState } from "react";

export const DEBOUNCED_SEARCH_DELAY_MS = 500;
export const DEBOUNCED_SEARCH_MIN_LENGTH = 3;

/**
 * Comportement de recherche partagé par /admin/utilisateurs, /admin/circuits
 * et /admin/reservations : debounce de 500ms, seuil de 3 caractères, et
 * "zone morte" pour 1-2 caractères (la valeur appliquée reste inchangée tant
 * que l'utilisateur n'a pas atteint 3 caractères ou vidé le champ).
 * Extrait verbatim de la logique historique d'useManageUsers.
 */
export const useDebouncedSearch = (initialValue = "") => {
  const [search, setSearch] = useState(initialValue);
  const [debouncedSearch, setDebouncedSearch] = useState(initialValue);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search.length >= DEBOUNCED_SEARCH_MIN_LENGTH) {
        setDebouncedSearch(search);
      } else if (search.length === 0) {
        setDebouncedSearch("");
      }
    }, DEBOUNCED_SEARCH_DELAY_MS);

    return () => clearTimeout(timer);
  }, [search]);

  return { search, setSearch, debouncedSearch };
};
